import { useParams } from 'react-router-dom';
import { useBoat, saveBoat, type BoatInput } from '../lib/boats';
import BoatForm from '../components/BoatForm';

export default function BoatDetail() {
  const { boatId } = useParams<{ boatId: string }>();
  const { boat, loading, error } = useBoat(boatId ?? null);

  if (loading) return <p className="text-sm text-gray-500">Laddar…</p>;
  if (error || !boat) {
    return (
      <p className="text-bad">
        Kunde inte ladda båten. Den kanske inte tillhör dig längre — kontakta
        styrelsen om det är fel.
      </p>
    );
  }

  const initial: BoatInput = {
    name: boat.name,
    model: boat.model,
    hullSerialNumber: boat.hullSerialNumber,
    modelYear: boat.modelYear,
    modelYearUnknown: boat.modelYearUnknown,
    engine: boat.engine,
    insuranceCompany: boat.insuranceCompany,
    measurementCert: boat.measurementCert,
    selfDeclaration: boat.selfDeclaration,
  };

  async function handleSave(values: BoatInput) {
    await saveBoat(boat!.id, values);
  }

  return (
    <section>
      <h1 className="text-2xl font-bold mb-4">
        Plats {boat.boatPlaceId} — {boat.name ?? '(utan namn)'}
      </h1>
      <BoatForm
        boatId={boat.id}
        initial={initial}
        onSave={handleSave}
        approval={boat.approval}
      />
    </section>
  );
}
